import { render, staticRenderFns } from "./jiaFangDJ.vue?vue&type=template&id=8de9385a&scoped=true"
import script from "./jiaFangDJ.vue?vue&type=script&lang=js"
export * from "./jiaFangDJ.vue?vue&type=script&lang=js"
import style0 from "./jiaFangDJ.vue?vue&type=style&index=0&id=8de9385a&prod&lang=css"
import style1 from "./jiaFangDJ.vue?vue&type=style&index=1&id=8de9385a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de9385a",
  null
  
)

export default component.exports